import { HeroSection } from './components/HeroSection';
import { ApplicationGrid } from './components/ApplicationGrid';
import { ValueProposition } from './components/ValueProposition';
import { TechnicalSpecs } from './components/TechnicalSpecs';
import { LicensingCTA } from './components/LicensingCTA';
import { Header } from '../../components/feature/Header';
import { Footer } from '../../components/feature/Footer';

const FCCTechnologyPage = () => {
  return (
    <main className="min-h-screen bg-slate-900">
      <Header />
      <HeroSection />
      <ApplicationGrid />
      <ValueProposition />
      <TechnicalSpecs />
      <LicensingCTA />
      <Footer />
    </main>
  );
};

export default FCCTechnologyPage;
